import React from "react";
import styled from "styled-components";
import { Col, Row } from "antd";
import { PlusOutlined, UserOutlined } from "@ant-design/icons";
import { CardHeader } from "../shared";
import EmptyState from "../EmptyState";
import HandymanItem from "./HandymanItem";
import { useBreakpoints } from "../../lib/breakpoints";

const HandymenSection = ({
  vendors,
  isVendorsLoading,
  onAddHandyman,
  onEditHandyman,
}) => {
  const { isTablet, isDesktop } = useBreakpoints();
  const buttonText = isTablet
    ? "Add Service Member"
    : "Add Service Team Member";

  return (
    <CardHeader
      title="Your Service Team"
      subtitle="Manage your trusted contractors and keep their info handy"
      actionButton={<PlusOutlined />}
      actionButtonText={buttonText}
      onActionClick={onAddHandyman}
    >
      <Row gutter={[24, 24]}>
        <Col xs={24}>
          <HandymanSectionContainer>
            <HandymanGrid>
              {isVendorsLoading ? (
                <LoadingContainer>Loading service team...</LoadingContainer>
              ) : vendors.length === 0 ? (
                <EmptyStateContainer>
                  <EmptyState
                    icon={<UserOutlined />}
                    title="No Service Team Members Added"
                    description="Save your go-to contractors and service team members"
                    ctaLabel="Add First Service Team Member"
                    ctaAction={onAddHandyman}
                    ctaIcon={
                      <FilteredIcon>
                        <PlusOutlined />
                      </FilteredIcon>
                    }
                  />
                </EmptyStateContainer>
              ) : (
                vendors.map((vendor) => (
                  <HandymanItem
                    key={vendor.id}
                    vendor={vendor}
                    onEdit={onEditHandyman}
                  />
                ))
              )}
            </HandymanGrid>
          </HandymanSectionContainer>
        </Col>
      </Row>
    </CardHeader>
  );
};

// Styled Components
const HandymanSectionContainer = styled.div`
  height: 100%;
  overflow: hidden;

  /* Add spacing between sections */
  & + & {
    margin-top: 1.5rem;
  }

  @media (max-width: 768px) {
    margin: 0 -0.5rem;
    border-radius: 8px;
    border-left: none;
    border-right: none;
  }
`;

const HandymanGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
`;

const LoadingContainer = styled.div`
  text-align: center;
  padding: 2rem;
  grid-column: 1 / -1;
  color: var(--color-text-light);
  font-size: 1rem;
`;

const EmptyStateContainer = styled.div`
  grid-column: 1 / -1;
`;

const FilteredIcon = styled.div`
  filter: brightness(0) invert(1);
`;

export default HandymenSection;
